import { SvgIcon } from '@material-ui/core'

export default function AlarmIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M6.53033 3.46967C6.82322 3.76256 6.82322 4.23744 6.53033 4.53033L4.03033 7.03033C3.73744 7.32322 3.26256 7.32322 2.96967 7.03033C2.67678 6.73744 2.67678 6.26256 2.96967 5.96967L5.46967 3.46967C5.76256 3.17678 6.23744 3.17678 6.53033 3.46967Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 4.5C7.30558 4.5 3.5 8.30558 3.5 13C3.5 17.6944 7.30558 21.5 12 21.5C16.6944 21.5 20.5 17.6944 20.5 13C20.5 8.30558 16.6944 4.5 12 4.5ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V13C11.25 13.2586 11.3832 13.4989 11.6025 13.636L14.6025 15.511C14.9538 15.7305 15.4165 15.6238 15.636 15.2725C15.8555 14.9212 15.7488 14.4585 15.3975 14.239L12.75 12.5843V8Z"
                fill="currentColor"
            />
            <path
                d="M17.4697 4.53033C17.1768 4.23744 17.1768 3.76256 17.4697 3.46967C17.7626 3.17678 18.2374 3.17678 18.5303 3.46967L21.0303 5.96967C21.3232 6.26256 21.3232 6.73744 21.0303 7.03033C20.7374 7.32322 20.2626 7.32322 19.9697 7.03033L17.4697 4.53033Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
